import React, { useEffect } from "react";
import MapImage from "../../assets/map2.png";
import Logo from "../../assets/logo.png";

const ContactUs: React.FC = () => {
  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="bg-gray-100 w-full h-full sm:h-full pb-8 2xl:h-full 2xl:py-40 flex flex-col justify-center items-center lg:px-0 px-4 ">
      <div className="container mx-auto text-center mb-8">
        <h1 className="2xl:text-7xl lg:text-6xl   font-bold text-4xl mt-24 text-center  text-palette1 mb-6 lg:mb-6">
          Contact Us
        </h1>
        <p className="text-gray-950 2xl:text-4xl lg:text-xl ">
          We'd love to hear from you! Reach out to us for inquiries,
          collaborations, or any questions you may have
        </p>{" "}
      </div>

      <div className="container  mx-auto p-6 bg-white rounded-lg shadow-lg xl:text-center  ">
        <div className="flex flex-col w-full lg:flex-row justify-center items-center mb-8">
         

          <div className="flex flex-col justify-center items-center ">
            <p className="text-xl font-medium text-palette1 mt-16 sm:mt-0">
              <img
                src={Logo} // Replace with the actual path to your image
                className="lg:w-full lg:p-16 w-full "
              />
            </p>
            <p className="text-xl font-medium  text-center  text-palette1 mb-2 mt-16 sm:mt-8">
              Visit Us:
            </p>
            <div className="flex justify-center text-center gap-8 items-center">
              <p className="text-palette3 mb-4">
                <span className="font-medium text-palette1">Legal Office</span>
                <br />
                Dream Innovation Srl
                <br />
                Via F. Parri, 1
                <br />
                Sant'Arpino (CE), 81030
                <br />
              </p>

              <p className="text-palette3 mb-4 ">
                <span className="font-medium text-palette1">Working Site</span>
                <br />
                Regus - Naples
                <br />
                Via Benedetto Brin, 63/Piano 2
                <br />
                Napoli (NA), 80142
                <br />
              </p>
            </div>

            <p className="text-xl font-medium text-palette1 mb-2  text-center ">
              Email Us:
            </p>
            <p className="text-palette3 mb-4  text-center ">
              info@dreaminnovation.it
            </p>
          </div>
          <img
            src={MapImage} // Replace with the actual path to your image
            alt="Google Maps Location"
            className="lg:w-1/2 lg:mr-8 rounded-md shadow-md"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
